import type { IdAndName } from '@/types/id-and-name'
import type { Nullable } from '@/types/utils'

export const joinArray = (array: (string | undefined)[]) =>
  array.filter(item => !!item).join(', ')

export const joinNameArray = (array: Nullable<Pick<IdAndName, 'name'>[]>) =>
  array?.map(item => item?.name).join(', ') ?? ''
